// import { useState } from 'react';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

// function PublishModal({ show, setShow }) {
//   const [selectedPlatform, setSelectedPlatform] = useState("telegram");
//   const [telegramApiKey, setTelegramApiKey] = useState("");

//   const handleClose = () => setShow(false);

//   return (
//     <>
//       <Modal show={show} onHide={handleClose} animation={false} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Publish</Modal.Title>
//         </Modal.Header>
        
//         <Modal.Body>
//           <p>Select a platform:</p>

//           <div className='d-flex gap-2 align-items-center'>
//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="platform"
//                 id="telegramRadio"
//                 value="telegram"
//                 checked={selectedPlatform === "telegram"}
//                 onChange={(e) => setSelectedPlatform(e.target.value)}
//               />
//               <label className="form-check-label" htmlFor="telegramRadio">
//                 Telegram
//               </label>
//             </div>

//             <div className="form-check">
//               <input
//                 className="form-check-input"
//                 type="radio"
//                 name="platform"
//                 id="whatsappRadio"
//                 value="whatsapp"
//                 checked={selectedPlatform === "whatsapp"}
//                 onChange={(e) => setSelectedPlatform(e.target.value)}
//               />
//               <label className="form-check-label" htmlFor="whatsappRadio">
//                 WhatsApp
//               </label>
//             </div>
//           </div>

//           {/* Show input box only when Telegram is selected */}
//           {selectedPlatform === "telegram" && (
//             <div className="mt-3">
//               <label htmlFor="telegramApiKey">Telegram API Key:</label>
//               <input
//                 type="text"
//                 id="telegramApiKey"
//                 className="form-control mt-1"
//                 value={telegramApiKey}
//                 onChange={(e) => setTelegramApiKey(e.target.value)}
//                 placeholder="Enter your Telegram API key"
//               />
//             </div>
//           )}
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleClose}>
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={() => {
//               handleClose();
//               console.log("Platform:", selectedPlatform);
//               if (selectedPlatform === "telegram") {
//                 console.log("Telegram API Key:", telegramApiKey);
//               }
//             }}
//           >
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }

// export default PublishModal;

import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import axiosInstance from '../../../utils/axiosInstance';
import { publishChnls } from '../../shared/ApiEndpoint';
import { notification } from 'antd';

const platforms = [
  {
    key: 'telegram',
    label: 'Telegram',
    fields: [
      {
        name:'aliasName',
        label:'Republish Alias Name',
        placeholder:'Enter your Republish Alias name',
        type:'text'
      },
      {
        name: 'apiKey',
        label: 'Telegram API Key',
        placeholder: 'Enter your Telegram API key',
        type: 'text'
      }
    ]
  },
  {
    key: 'whatsapp',
    label: 'WhatsApp',
    // fields: [
    //   {
    //     name:'aliasName',
    //     label:'Republish Alias Name',
    //     placeholder:'Enter your Republish Alias name',
    //     type:'text'
    //   },
    //   {
    //     name: 'accountsid',
    //     label: 'Twillo Account SID',
    //     placeholder: 'Enter your Twillo Account SID',
    //     type: 'text'
    //   },
    //   {
    //     name: 'authtoken',
    //     label: 'Twillo Auth Token',
    //     placeholder: 'Enter your Twillo Auth Token',
    //     type: 'text'
    //   },
    //   {
    //     name: 'businessnumber',
    //     label: 'Business Whatsapp Number',
    //     placeholder: 'Enter your Business Whatsapp Number',
    //     type: 'text'
    //   }
    // ]
    fields: [
      {
        name:'aliasName',
        label:'Republish Alias Name',
        placeholder:'Enter your Republish Alias name',
        type:'text'
      },
      {
        name: 'apiEndpoint',
        label: 'Wati Api Endpoint',
        placeholder: 'Enter your Wati Api Endpoint',
        type: 'text'
      },
      {
        name: 'apiKey',
        label: 'Wati Api Key',
        placeholder: 'Enter your Wati Api Key',
        type: 'text'
      },
      {
        name: 'businessnumber',
        label: 'Business Whatsapp Number',
        placeholder: 'Enter your Business Whatsapp Number',
        type: 'text'
      }
    ]
  }
];

const generateInitialValues = () => {
  const initial = {};
  platforms.forEach((platform) => {
    initial[platform.key] = {};
    platform.fields.forEach((field) => {
      initial[platform.key][field.name] = '';
    });
  });
  return initial;
};

function PublishModal({ show, setShow,publishModalDetails}) {
  const [selectedPlatform, setSelectedPlatform] = useState('telegram');
  const [formValues, setFormValues] = useState(generateInitialValues());
  const [errorValidate, setErrorValidate] = useState(generateInitialValues());

  const handleClose = () => {
    setShow(false);
    setSelectedPlatform('telegram');
    setFormValues(generateInitialValues());
    setErrorValidate(generateInitialValues());
  };

  const handleInputChange = (platformKey, fieldName, value) => {
    setFormValues((prev) => ({
      ...prev,
      [platformKey]: {
        ...prev[platformKey],
        [fieldName]: value
      }
    }));

    setErrorValidate((prev) => ({
      ...prev,
      [fieldName]: false
    }));
  };

  const handleSave = () => {
    const currentValues = formValues[selectedPlatform];
    let isValid = true;

    const newErrors = {};
    platforms
      .find((p) => p.key === selectedPlatform)
      .fields.forEach((field) => {
        newErrors[field.name] = !currentValues[field.name];
        if (!currentValues[field.name]) isValid = false;
      });

    setErrorValidate((prev) => ({
      ...prev,
      [selectedPlatform]: newErrors
    }));

    if (!isValid) return;
    const payload = {
      Platform: selectedPlatform,
      bot_id: publishModalDetails.bot_id,
      bot_name: publishModalDetails.bot_name,
      ...currentValues
    };
    console.log(payload);
    console.log(selectedPlatform);
    handlePublishBots(payload,selectedPlatform);
    handleClose();
  };

  const handlePublishBots = async(payload,selectedPlatform)=>{
  try {
    const res = await axiosInstance.post(
      `${publishChnls}/${payload.bot_id}`,
      payload,
      { withCredentials: true }
    );
    if(res.status===200){
       notification.success({
        key: 'channelcreate-success',
        description: "Channel Published Successfully",
        placement: 'topRight',
      });
      console.log(res.data);
       notification.success({
        key: 'channelcreate-success',
        description: "Channel Published Successfully",
        placement: 'topRight',
      });

    }
  } catch (error) {
    console.log(error)
         if(error.status===400){
       notification.error({
        key: 'channelcreate-Failed',
        description: "Failed to Published the Channel",
        placement: 'topRight',
      });
    }
  }
  }
  const currentPlatform = platforms.find((p) => p.key === selectedPlatform);
  return (
    <Modal show={show} onHide={handleClose} animation={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Publish {publishModalDetails.bot_name}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Select a platform:</p>
        <div className="d-flex gap-3">
          {platforms.map((platform) => (
            <div className="form-check" key={platform.key}>
              <input
                className="form-check-input"
                type="radio"
                name="platform"
                id={`${platform.key}Radio`}
                value={platform.key}
                checked={selectedPlatform === platform.key}
                onChange={() => setSelectedPlatform(platform.key)}
              />
              <label className="form-check-label" htmlFor={`${platform.key}Radio`}>
                {platform.label}
              </label>
            </div>
          ))}
        </div>

        {currentPlatform.fields.length > 0 && (
          <div className="mt-3">
            {currentPlatform.fields.map((field) => (
              <Form.Group key={field.name} className="mb-3">
                <Form.Label>{field.label}</Form.Label>
                <Form.Control
                  type={field.type}
                  placeholder={field.placeholder}
                  value={formValues[selectedPlatform]?.[field.name] || ''}
                  onChange={(e) =>
                    handleInputChange(selectedPlatform, field.name, e.target.value)
                  }
                />
              </Form.Group>
            ))}
              {errorValidate.apiKey && <p className='text-danger'>Please Enter API Key</p>}
          </div>
        )}
      
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Publish
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PublishModal;

